// src/redux/store.js
// import { createStore } from 'redux';
// import rootReducer from './reducers';

// const store = createStore(rootReducer);

// export default store;



// import { configureStore } from '@reduxjs/toolkit';
// import tripReducer from './slice/tripSlice'; // New tripSlice reducer
// import rootReducer from './reducers/'; // Your existing serviceTypeReducer

// const store = configureStore({
//   reducer: {
//     trip: tripReducer,           // Manages trip data
//     serviceType: rootReducer, // Manages the serviceType
//   },
// });

// export default store;


import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Default storage for web
import tripReducer from "./slice/tripSlice"; // Your tripSlice reducer
import rootReducer from "./reducers/"; // Your existing serviceTypeReducer

// Combine your reducers
const reducers = combineReducers({
  trip: tripReducer, // Manages trip data
  serviceType: rootReducer, // Manages the serviceType
});

// Persist configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["trip"], // Specify which reducers you want to persist
};

// Create the persisted reducer
const persistedReducer = persistReducer(persistConfig, reducers);

// Configure the store
const store = configureStore({
  reducer: persistedReducer, // Use the persisted reducer
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializability checks for redux-persist
    }),
});

// Create the persistor
const persistor = persistStore(store);

export { store, persistor };

